import { motion } from 'motion/react';
import { AnimatedMark } from '@/components/brand/triangle-motif';

/** Full-screen loading state while the session is restored. */
export function Splash() {
  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-bg"
      role="status"
      aria-live="polite"
    >
      <motion.div
        animate={{ scale: [1, 1.06, 1] }}
        transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
      >
        <AnimatedMark className="size-16" />
      </motion.div>
      <p className="text-sm text-fg-muted">Loading your workspace…</p>
    </div>
  );
}
